<button
  mat-icon-button
  [disabled]="disabled"
  [matMenuTriggerFor]="menu"
  [color]="iconColour$ | async"
  [matTooltip]="tooltip$ | async"
>
  <mat-icon>price_change</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <pr-staff-fee-schedule-menu-items
    [feeSchedule]="defaultFeeSchedule$ | async"
    [multiSelect]="multiSelect"
    (scheduleSelected)="scheduleSelected.emit($event)"
  />
</mat-menu>
